<template>
  <div>
    <div v-if="message.type != 'notification'" :class="message.from == fromUser ? 'msg-line-to' : 'msg-line-from'"
         class="msg-line">
      <img :key="message.idServer" :src="avatar" alt="" class="msg-nick">
      <div class="msg-cont">
        <div v-if="message.from != fromUser" class="msg-cont-name">
          {{ message.fromNick }}
          <span>{{ formatDate(message.time) }}</span>
        </div>
        <!--       回复信息-->
        <div v-if="isReview" :key="isReview" class="msg-cont-word" @click.right="rightClick($event,message)">
          <div v-if="aitMsg.type === 'text'" class="ait-info">
            {{ aitMsg.fromNick }}：
            <span v-html="contMatch(aitMsg)"></span>
          </div>
          <div v-else-if="aitMsg.type === 'custom'" class="ait-info" style="cursor: pointer" @click="goUrl">
            {{ aitMsg.fromNick }}：[自定义]
          </div>
          <a v-else-if="aitMsg.file" :href="aitMsg.file.url" class="ait-info" target="_blank">
            {{aitMsg.fromNick}}：{{ aitMsg.type === 'image' ? '[图片]' : '[文件]' }}
          </a>
          <div class="isReview" v-html="contMatch(message)"></div>
        </div>
        <!--       正常发送信息显示-->
        <template v-else>
          <div v-if="message.type === 'text'" class="msg-cont-word" v-html="contMatch(message)"
               @click.right="rightClick($event,message)"></div>
          <div v-else-if="message.type === 'image'" class="msg-cont-img" @click.right="rightClick($event,message)">
            <el-image
              :preview-src-list="[message.file.url]"
              :src="message.file.url"
              fit="contain"
              style="width: 100px;">
            </el-image>
          </div>
<!--          <a v-else-if="message.type === 'file'" :download="message.file.name" :href="message.file.url" class="msg-cont-file"-->
          <div v-else-if="message.type === 'file'" @click="onDownFile(message.file.url , message.file.name)" class="msg-cont-file"
             target="_blank" @click.right="rightClick($event,message)">
            <img v-if="'png,jpg,jpeg'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/png.png">
            <img v-else-if="'xls,xlsx'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/excel.png">
            <img v-else-if="'pdf'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/pdf.png">
            <img v-else-if="'txt'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/txt.png">
            <img v-else-if="'doc,docx'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/word.png">
            <img v-else-if="'zip'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/zip.png">
            <img v-else-if="'ppt,pptx'.indexOf(message.file.ext) !== -1" alt=""
                 class="msg-cont-file-img" src="@/assets/img/fileType/ppt.png">
            <img v-else alt="" class="msg-cont-file-img" src="@/assets/img/fileType/unknow.png">
            <div>
              <div class="msg-cont-file-name">{{ message.file.name }}</div>
              <div class="msg-cont-file-size">{{
                  message.file.size <= 1024 ? message.file.size + ' B' : message.file.size / 1048576 > 1 ? (message.file.size / 1048576).toFixed(2) + ' M' : (message.file.size / 1024).toFixed(0) + ' KB'
                }}
              </div>
            </div>
          </div>
          <audio v-else-if="message.type === 'audio'" :src="message.file.mp3Url" class="msg-cont-audio"
                 controls></audio>
          <div v-else-if="message.type === 'custom' && aitInfo" class="msg-cont-custom">
            <div class="msg-custom-info" style="cursor: pointer" @click="goUrl">
              <img :src="aitInfo.product_pic" alt="">
              <div class="msg-custom-info-des">
                <div class="limit-2">{{ aitInfo.product_name }}</div>
                <div class="limit-2">{{ aitInfo.product_desc }}</div>
                <div class="msg-custom-info-quantity">x{{ aitInfo.product_quantity }}</div>
              </div>
            </div>
            <div class="msg-custom-tip">{{
                aitInfo.doctor_status == 1 ? '学员已领用耗材，该订单无需导师再次确认' : aitInfo.doctor_status == 2 ? '学员拒绝了该耗材' : '导师为您挑选了该耗材，是否领用？'
              }}
            </div>
            <div v-if="aitInfo.doctor_status == 0" class="msg-custom-btn">
              <div @click="takeThings(false)">暂不领用</div>
              <div @click="takeThings(true)">领用</div>
            </div>
          </div>
          <div v-else class="msg-cont-word">消息已被撤回</div>
        </template>
      </div>
    </div>
<!--    <div v-else class="msg-toast">-->
<!--      <span v-for="item in message.attach.users">{{ item.nick + ' ' }}</span> 加入了群聊-->
<!--    </div>-->
  </div>
</template>

<script>
import contMatch from "@/utils/contMatch"
import {DoctorClaim, DoctorReject} from "@/http/api";

export default {
  name: "ChatMessage",
  data() {
    return {
      rightMenuId: '',
      msgOptionPosition: [],
      aitInfo: null,
      aitMsg: {},
      isReview: false
    }
  },
  props: {
    message: {
      type: Object
    },
    fromUser: '',
    toUser: '',
    avatar: '',
    nim: null
  },
  mounted() {
    console.log('1111111')
    console.log(this.avatar)
    if (this.message.custom) {
      this.aitInfo = JSON.parse(this.message.custom)
      if (this.message.type && this.message.type != 'custom') {
        this.isReview = true
        this.nim.getLocalMsgByIdClient({
          idClient: this.aitInfo.yxReplyMsg.idClient,
          done: (err, data) => {
            this.aitMsg = data.msg
          }
        })
      }
    }
  },
  methods: {
    contMatch(data) {
      return contMatch(data)
    },
    formatDate(date) {
      let t = new Date(date).toLocaleString()
      return t.substring(0, t.length - 3)
    },
    rightClick(e, info) {
      this.msgOptionPosition[0] = e.clientX
      this.msgOptionPosition[1] = e.clientY
      this.$emit('rightClick', this.msgOptionPosition, info)
    },
    msgChange(data) {
      console.log('msgChange')
      this.message.type = data
    },
    goUrl() {
      if (this.message.type == 'custom') {
        window.open("/consumables/detail/" + this.aitInfo.product_id, '_blank')
      } else {
        this.nim.getLocalMsgByIdClient({
          idClient: this.aitInfo.yxReplyMsg.idClient,
          done: (err, data) => {
            let goods = JSON.parse(data.msg.custom)
            window.open("/consumables/detail/" + goods.product_id, '_blank')
          }
        })
      }
    },
    takeThings(type) {
      if (type) {
        DoctorClaim({order_id: this.aitInfo.id}).then(res => {
          if (res.code == 200) {
            let info = JSON.parse(JSON.stringify(this.aitInfo))
            info.doctor_status = 1
            this.$parent.sendMsg('order', info)
          } else {
            this.$message({
              type: 'error',
              message: res.message[0]
            })
          }
        })
      } else {
        DoctorReject({order_id: this.aitInfo.id}).then(res => {
          if (res.code == 200) {
            let info = JSON.parse(JSON.stringify(this.aitInfo))
            info.doctor_status = 2
            this.$parent.sendMsg('order', info)
          } else {
            this.$message({
              type: 'error',
              message: res.message[0]
            })
          }
        })
      }
    },
    onDownFile(url, filename) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, filename)
      })
    },

    getBlob(url, cb) {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (xhr.status === 200) {
          cb(xhr.response)
        }
      }
      xhr.send()
    },

    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      }
      else {
        var link = document.createElement('a')
        var body = document.querySelector('body')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename

        link.style.display = 'none'
        body.appendChild(link)

        link.click()
        body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      }
    },
  }
}
</script>

<style scoped src="../../../assets/css/chat.css">

</style>
<style>
.msg-cont-img img{
  border-radius: 6px;
}
</style>
